export interface ExperienceEntry {
  id: string;
  title: string;
  company: string;
  duration: string;
  /** Font Awesome class suffix, e.g. "code" renders `fa fa-code` */
  icon: string;
  current?: boolean;
  /** A string renders as a paragraph, an array as a bullet list */
  body: string | string[];
}

// Newest first, the order the Home timeline shows.
export const experience: ExperienceEntry[] = [
  {
    id: "evently",
    title: "Founder & Full Stack Developer",
    company: "Evently (evently.ph)",
    duration: "July 2024 - Present",
    icon: "star",
    current: true,
    body: "Developed and launched an online event booking system while serving as the full-stack developer. Built the front end using React, the backend with Golang, and the database with PostgreSQL. Utilized AWS services for infrastructure and leveraged Terraform for deployment automation.",
  },
  {
    id: "devy",
    title: "Full Stack Developer",
    company: "Devy",
    duration: "Feb 2026 - Present",
    icon: "code",
    body: "Designed and implemented responsive frontend applications with React and TypeScript, plus a companion mobile app built with React Native. Developed backend services and APIs using Node.js and TypeScript, and collaborated within Agile teams to ship production-ready applications. Stack: React, React Native, TypeScript, Node.js, Next.js, PostgreSQL, Convex, and Clerk.",
  },
  {
    id: "askrella",
    title: "Full Stack Developer",
    company: "Askrella",
    duration: "Feb 2024 - Feb 2026",
    icon: "code",
    body: "Designed and implemented responsive frontend applications with React and TypeScript, and built backend services and APIs with Go, Python, and Node.js. Managed and optimized PostgreSQL and Neo4j data stores, deployed and maintained apps on AWS, automated infrastructure with Terraform, and containerized services with Docker in an Agile environment.",
  },
  {
    id: "broadpath",
    title: "Development Team Lead",
    company: "BroadPath",
    duration: "March 2020 - October 2023",
    icon: "users",
    body: "Led software development initiatives across frontend, backend, and data analytics projects. Reviewed code contributions, enhanced and maintained enterprise applications in production, and drove automated and manual testing for release readiness. Built reporting and analytics solutions from large-scale datasets, combining data from multiple sources into business insights, and collaborated cross-functionally to improve performance and reliability. Stack: C#, F#, .NET, Elm, Node.js, Python, Databricks, Azure Functions, and Microsoft SQL Server.",
  },
  {
    id: "upwork",
    title: "Freelance Developer",
    company: "Upwork",
    duration: "October 2015 - Present",
    icon: "laptop",
    body: [
      "Developed custom web applications for clients from initial planning through deployment",
      "Resolved complex software issues and performance bottlenecks for client systems",
      "Developed automation bots for repetitive operational workflows",
      "Built web scraping solutions for data collection, reporting, and analytics",
      "Built cryptocurrency backtesting systems integrated with AI-driven analysis workflows",
      "Developed automated live trading systems for cryptocurrency markets",
    ],
  },
  {
    id: "utalk",
    title:
      "Full Stack Developer → Head of Software Development → Director of Software Application Development",
    company: "Utalk Philippines",
    duration: "March 2016 - March 2020",
    icon: "building",
    body: "Progressed from full-stack developer to leading the software development department. Managed an engineering team responsible for applications serving thousands of users, automated operational workflows to boost efficiency, and supervised the full development lifecycle from planning through deployment. Guided managers and teams on engineering best practices, contributed to strategic technical planning and architecture decisions, and collaborated with stakeholders to deliver scalable business applications.",
  },
  {
    id: "global-axxess",
    title: "Full Stack Developer",
    company: "Global Axxess Solutions",
    duration: "January 2015 - January 2016",
    icon: "globe",
    body: "Developed web applications and automation systems to improve operational efficiency, built e-commerce platforms supporting business expansion, and maintained and enhanced existing software systems. Stack: HTML, JavaScript, PHP, WordPress, CodeIgniter, MySQL, and SQLite.",
  },
  {
    id: "wow-stream",
    title: "Software Application Developer",
    company: "Wow Stream",
    duration: "August 2014 - October 2014",
    icon: "desktop",
    body: "Optimized existing websites and internal applications, improving application performance and frontend responsiveness. Stack: HTML, CSS, JavaScript, PHP, Kohana, Java, and MySQL.",
  },
  {
    id: "prosoft",
    title: "Intern Web Developer / Designer",
    company: "Prosoft Solutions",
    duration: "April 2014 - July 2014",
    icon: "graduation-cap",
    body: "Designed and developed web assets and marketing materials for clients, and assisted with frontend development and website maintenance activities. Stack: HTML, CSS, JavaScript, PHP, WordPress, CodeIgniter, and MySQL.",
  },
];
